export default "__VITE_ASSET__Dg$uwnqE__"